import { css, html, LitElement } from 'lit-element';
import '@giswebgroup/ki-wcp-base/src/components/ki-table/ki-table';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import "@giswebgroup/ki-wcp-base/src/components/ki-icon/ki-icon"
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import * as moment from 'moment';
import computed from '@giswebgroup/ki-wcp-base/src/decorators/computed';
import { Status } from './StatusFormatter';
import nls from '../../locales/index.nls';
/*
 * Compare to ki-table, this component
 * 1. should provide buildin default columns Ui and format with kiwis data.
 * 2. should connect to kiwis.
 *
 *
 */

export default
@i18n(nls)
class KiStationTable extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      display: block;
    }
    .header {
      height: 50px;
      position: absolute;
      width: 100%;
      z-index: 1;
    }

    .content {
      z-index: 0;
      padding: 60px 10px 10px;
      position: relative;
      height: 100%;
      box-sizing: border-box;
      color: #4a4a49;
    }
    ki-table {
      height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .icon-btn {
      color: gray;
      background: white;
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 36px;
      font-size: 20px;
      cursor: pointer;
      position: absolute;
      padding: 8px;
      box-sizing: border-box;
    }

    .icon-btn ki-icon {
      display: block;
    }

    .icon-btn:hover {
      color: #4a4a49;
    }

    .download-btn {
      top: 15px;
      right: 15px;
    }

    .expand-btn {
      top: 15px;
      right: 55px;
    }

    .tooltip-content {
      white-space: nowrap;
    }

    :host(.hscroll) ki-table::part(table) {
      width: auto;
    }
  `;

  static get properties() {
    return {
      stations: { type: Array },
      tagStyles: { type: Object },
      selection: { type: Array },
      scrollbar: { type: Boolean },
    };
  }

  constructor(){
    super();
    this.scrollbar =  false;
  }

  @computed(['tagStyles'])
  get formatters() {
    const styles = this.tagStyles;
    
    const catchmentTagStyles = this.catchmentTagStyles;
    const catchmentCalcTagStyles = this.catchmentCalcTagStyles;
    const self = this;
    const iconStyles = {
      0: html`<svg style="width:18px;fill:gray;" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M16.5 9l-5.74-5.5c-.79.76-.79 1.99 0 2.75l1.86 1.78H1.5v1.94h11.12l-1.86 1.78c-.79.76-.79 1.99 0 2.75L16.5 9z"/></svg>
          `,
      1: html`<svg style="width:18px;fill:gray;" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M9 1.5L3.5 7.24c.76.79 1.99.79 2.75 0l1.78-1.86V16.5h1.94V5.38l1.78 1.86c.76.79 1.99.79 2.75 0L9 1.5z"/></svg>
      `,
      '-1': html`<svg style="width:18px;fill:gray;" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" viewBox="0 0 18 18"><path d="M9 16.5l5.5-5.74c-.76-.79-1.99-.79-2.75 0l-1.78 1.86V1.5H8.03v11.12l-1.78-1.86c-.76-.79-1.99-.79-2.75 0L9 16.5z"/></svg>
      `,
    };
    return {
      translate(val) {
        return self.i18n.t(val) ? html`${self.i18n.t(val)}` : html`<span></span>`;
      },
      status(val) {
        return Status(styles[val]);
      },
      catchmentstatus(val) {
        return Status(catchmentTagStyles[val]);
      },
      catchmentstatuscalc(val) {
        return Status(catchmentCalcTagStyles[val]);
      },
      tendency(val) {
        // todo move into options.
        return html`<div class="cell" style="text-align: center;">${iconStyles[val] ? iconStyles[val] : ""}</div>`;
      },
    };
  }

  @query('#station-table')
  __stationTable;

  _renderDownloadControl() {
    return html`
    <div class="icon-btn expand-btn" title="${this.scrollbar ? 'réduire la table' : 'élargir la table'}" @click="${this.toggleScroll}">
      <ki-icon icon="${this.scrollbar ? 'ki ki-compress' : 'ki ki-expand'}" ></ki-icon>
    </div>
    <div title="${this.i18n.t('Download_station_list')}" class="icon-btn download-btn" id="download-btn" @click="${() => {this.dispatchEvent(
      new CustomEvent("downloadstationsmd", {
        bubbles: true
      }),
    )}}">
      <ki-icon icon="ki ki-arrow-alt-to-bottom"></ki-icon>
    </div>
    `;
  }

  toggleScroll(){
    this.scrollbar = !this.scrollbar;
    this.classList.toggle('hscroll', this.scrollbar);
  }

  render() {
    // language=html
    return html`
      <div class="header">${this._renderDownloadControl()}</div>
      <div class="content">
        <ki-table
          id="station-table"
          .multiselection="${true}"
          .data="${this.stations}"
          .selection="${this.selection}"
          idproperty="station_no"
          .formatters="${this.formatters}"
          .columns="${this.columns}"
          .localStorageId="${this.localStorageId}"
          sort='[{"field":"station_name", "ascending":true}]'
          @row-click="${this._onStationClick}"
        ></ki-table>
      </div>
    `;
  }

  _onStationClick(e) {
    // eslint-disable-next-line camelcase
    const station = e.detail.data;
    station && this.dispatchEvent(new CustomEvent('station-click', { detail: { value: `${station.site_no}/${station.station_no}` } }));
  }

  onShow() {
    this.__stationTable && this.currentStationId && this.__stationTable.scrollTo(this.currentStationId.split('/')[1]);
  }
}

customElements.define('ki-station-table', KiStationTable);
